<template id="">
<div>
  <page-header v-if="person" :title="person.name">
    <template slot="primary">
      <div class="mb-1" v-if="person.jobTitle" style="font-weight:bold;color:green;">
        <span>{{person.jobTitle}}</span>
        <span v-if="person.domain"> at
          <a class="simple-link" :href="'http://' + person.domain" target="_blank">{{person.domain}}</a>
        </span>
      </div>
      <div class="">
        <img class="mr-3" v-if="person.country" :src="'https://www.countryflags.io/' + person.country.id + '/flat/24.png'" alt="">
      </div>
    </template>
    <template slot="secondary">
      <div>
        <div>
          <span>{{localTime}}</span>
          <span v-if="person.location"> in {{person.location.city}}, {{person.location.country_name}}</span>
        </div>
        <div>Joined {{person.createdAt | moment('from')}}</div>
      </div>
      <div>
      </div>
    </template>
    <template slot="action">
      <b-row class="mt-3">
        <b-col md="4">
          <member-status-control :member="person"></member-status-control>
        </b-col md="8">
        <b-col class="text-right">
          <member-call-button :member="person"></member-call-button>
          <member-email-button :member="person" class="ml-2"></member-email-button>
          <member-text-button :member="person" class="ml-2"></member-text-button>
          <member-schedule-button :member="person" class="ml-2"></member-schedule-button>
        </b-col>
      </b-row>
    </template>
  </page-header>

  <b-container v-if="person">
    <b-tabs content-class="mt-3">
      <b-tab title="Notes" active>
        <member-feed-tab :member="person"></member-feed-tab>
      </b-tab>
      <b-tab title="Profile">
        <member-profile-tab :member="person"></member-profile-tab>
      </b-tab>
      <b-tab title="Opportunities">
        <member-opportunities-tab :member="person"></member-opportunities-tab>
      </b-tab>
      <!--
      <b-tab title="Company" v-if="person.company">
        <member-company-tab :company="person.company"></member-company-tab>
      </b-tab>
      -->
      <b-tab title="Call History">
        <member-phone-tab :member="person"></member-phone-tab>
      </b-tab>
      <b-tab title="Email History">
        <member-email-tab :member="person"></member-email-tab>
      </b-tab>
      <b-tab title="SMS History">
        <member-text-tab :member="person"></member-text-tab>
      </b-tab>
    </b-tabs>
  </b-container>
</div>
</template>
<script>
import PageHeader from '@/components/global/PageHeader';
import ct from 'countries-and-timezones';
import $auth from '@/services/auth.js';

import {GetMember} from '@/gql/members/Members.gql';
import MemberProfileTab from '@/components/members/MemberProfileTab';
import MemberFeedTab from '@/components/members/MemberFeedTab';
import MemberCompanyTab from '@/components/members/MemberCompanyTab';
import MemberAnswersTab from '@/components/members/MemberAnswersTab';
import MemberOpportunitiesTab from '@/components/members/MemberOpportunitiesTab';
import MemberTextTab from '@/components/members/MemberTextTab';
import MemberEmailTab from '@/components/members/MemberEmailTab';
import MemberPhoneTab from '@/components/members/MemberPhoneTab';
import MemberCallButton from '@/components/members/MemberCallButton';
import MemberEmailButton from '@/components/members/MemberEmailButton';
import MemberTextButton from '@/components/members/MemberTextButton';
import MemberScheduleButton from '@/components/members/MemberScheduleButton';
import MemberStatusControl from '@/components/members/MemberStatusControl';

export default {
  components: {
    PageHeader,
    MemberFeedTab,
    MemberProfileTab,
    MemberOpportunitiesTab,
    MemberCompanyTab,
    MemberAnswersTab,
    MemberTextTab,
    MemberPhoneTab,
    MemberEmailTab,
    MemberEmailButton,
    MemberCallButton,
    MemberScheduleButton,
    MemberTextButton,
    MemberStatusControl,
  },
  data() {
    return {
      currentUserId: $auth.getUserId(),
    }
  },
  apollo: {
    person: {
      query: GetMember,
      variables() {
        return {
          id: this.$route.params.id
        }
      }
    }
  },
  computed: {
    localTime() {
      return this.$moment.tz(this.person.timezone).format('HH:mm');
    },
  }
}
</script>
